export async function lightbox() {
    const lightboxTrigger = document.querySelectorAll('[data-lightbox]');

    if (lightboxTrigger) {
        const { initLightboxes } = await import(/* webpackMode: "lazy" */ './lightbox.async.js');

        initLightboxes();
    }
}
